import { Component, OnInit } from '@angular/core';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { MessageService } from 'src/app/data-services/message.service';
import { first } from 'rxjs-compat/operator/first';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.css']
})
export class RankingComponent implements OnInit {
  awards1:any;
  years = [];
  searchText: string;
  id: number;
  name: string;
  currentUser: any;
  countries = [];
  title: string;
  isLoaderVisible = false;
  fans = [];
  ranking :any;
  language = '';
  direction;
  defaultLanguage;

  constructor(
    private route: ActivatedRoute,
    private iffhsService: IffhsService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private messageService: MessageService) {
    this.messageService.selectedLanguage.subscribe(res => {
      this.language = res.lang;
      this.direction = res.dir;
    });
  }
  ngOnInit(): void {
    window.scrollTo(0, 0)
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    // this.route.queryParams.subscribe(params => {
    //   this.id = params['id'];
    //   this.name = params['name'];
    // });
    this.getAllRanking();
    this.getRankingawards();
    this.fans = Array(11).fill(0).map((x, i) => ({ id: (i + 1), name: `Coming Soon` }));
    this.years = Array(5).fill(0).map((x, i) => ({ id: (i + 2020) }));

    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
  }
  getAllRanking() {
    
    this.iffhsService.getAllRanking().pipe().subscribe((res: any) => {
      this.ranking = res.ranking;
    });
  }
  getRankingawards() {
    this.iffhsService.getAllAwards().pipe().subscribe((res: any) => {
      this.awards1 = res.awards;
      console.log(this.awards1);
    });
  }
  // getRanking() {
  //   const data = {
  //     awardId: this.id,
  //   };
  //   this.iffhsService.getAwardDetails(data).subscribe((res: any) => {
  //     this.awards = res.awards;
  //     this.title = res.title.name;
  //     this.countries = res.countries;
  //     this.isLoaderVisible = false;
  //     console.log(this.awards);
  //   });
  // }


}
